import CreateSeedAudienceAdPlatformView from './CreateSeedAudiencesAdPlatform.View';

const CreateSeedAudienceAdPlatform = () => <CreateSeedAudienceAdPlatformView />;

export default CreateSeedAudienceAdPlatform;
